module.exports = __webpack_public_path__ + "img/dsci0027.5f972f22.jpg";